import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
// import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';



@Injectable({
  providedIn: 'root'
})

export class ServicesService {
  tempData: any;

  apiUrl = environment.apiUrl;
  url: string;
  tokenVal: any = '';

  constructor(private _http: HttpClient, private router: Router) {
    this.url = 'https://api.datamuse.com/words?ml=';
  }

  checkLogin(login) {
    const data = {
      email_id: login.name, password: login.password,
      device_token: login.device_token, device_type: login.device_type
    };
    // const reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencodeed'});
    return this._http.post(this.apiUrl + '/login', data);
  }

  checkToken(serverTokenStatus) {
    if (serverTokenStatus == '401') {
      localStorage.removeItem('userToken');
      this.router.navigateByUrl('/');
      return false;
    }
    if (localStorage.getItem('userToken')) {
      return true;
    } else {
      this.router.navigateByUrl('/');
      return false;
    }
  }

  getToken() {
    return localStorage.getItem('userToken');
  }

  postRequest<T>(param, route, token?): Observable<T> {
    const header = new HttpHeaders();
    token = token || this.getToken();
    const other_headers = header.append('Authorization', 'Bearer ' + token);
    return this._http.post<T>(this.apiUrl + '/' + route, param, { headers: other_headers });
  }

  deleteRequest(id, route, token): Observable<{}> {
    const other_header = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    const options = { headers: other_header };
    return this._http.delete<{}>(this.apiUrl + '/' + route + '/' + id, options);
  }

  getRequestNoToken(route): Observable<{}> {
    return this._http.get<{}>(this.apiUrl + '/' + route);
  }


  getUserData(param): Observable<{}> {
    const header = new HttpHeaders();
    const other_header = header.append('Authorization', 'Bearer ' + param.token);
    return this._http.post<{}>(this.apiUrl + '/user', '', { headers: other_header });
  }

  requestCreator(param, route, token): Observable<{}> {
    const header = new HttpHeaders();
    const other_header = header.append('Authorization', 'Bearer ' + token);
    return this._http.post<{}>(this.apiUrl + '/' + route, param, { headers: other_header });
  }
  requestCreatorPDF(param, route, token): Observable<Blob> {
    const header = new HttpHeaders().append('Authorization', 'Bearer ' + token);
    const options = { headers: header, responseType: 'blob' as 'json' }; // Specify responseType as 'blob'
    return this._http.post<Blob>(this.apiUrl + '/' + route, param, options);
  }

  constructionSummaryMail(param, token): Observable<{}> {
    const other_header = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    const options = { headers: other_header,
      'Access-Control-Allow-Origin': '*' };
    return this._http.post<{}>(this.apiUrl + '/construction-summary-mail', param, options);
  }


  getConstructionHealthCheck(id, token): Observable<{}> {
    const header = new HttpHeaders();
    const other_header = header.append('Authorization', 'Bearer ' + token);
    return this._http.post<{}>(this.apiUrl + '/get-health-checks' ,{}, { headers: other_header })
  }

  // getConstructionHealthCheck(id, token): Observable<{}> {
  //   const header = new HttpHeaders();
  //   const other_header = header.append('Authorization', 'Bearer ' + token);
  //   return this._http.post<{}>(this.apiUrl + '/get-single-health' ,{"construction_id":id}, { headers: other_header })
  // }

  /* Get Construction QR Code */
  getQRCode(id, token): Observable<{}> {
    const other_header = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    const options = { headers: other_header };
    return this._http.post<{}>(this.apiUrl + '/get-web-qrcode?construction_id=' + id, {}, options);
  }

}
